export function getActiveColumns(columns, userColumns) {
    if (!userColumns || !userColumns.length) {
        return columns;
    }
    return columns.map(col => (Object.assign(Object.assign({}, col), { active: userColumns.includes(col.id) })));
}
